import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=75c4cc3f"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"
import style0 from "./structure.vue?vue&type=style&index=0&id=75c4cc3f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c4cc3f')) {
      api.createRecord('75c4cc3f', component.options)
    } else {
      api.reload('75c4cc3f', component.options)
    }
    module.hot.accept("./structure.vue?vue&type=template&id=75c4cc3f", function () {
      api.rerender('75c4cc3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/structure.vue"
export default component.exports